import { useTranslation } from 'react-i18next';

const NewDecoration = () => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        display: 'inline-block',
        backgroundColor: '#00ffe0',
        color: 'black',
        padding: '0.25rem 0.75rem',
        borderRadius: '9999px',
        fontSize: '1rem',
        fontWeight: 500,
        lineHeight: 1.4,
        marginLeft: '0.5rem',
      }}
    >
      {t('sunshine.label.new')}
    </div>
  );
};

export default NewDecoration;
